module.exports = __webpack_public_path__ + "img/308.acea8848.jpg";